import { Cpu, ShieldCheck, Mail, Info } from "lucide-react";

const Tricolore = () => (
  <span className="inline-flex overflow-hidden rounded-sm border border-[#1E2638]" aria-hidden="true">
    <span className="h-4 w-2 bg-[#0055A4]" />
    <span className="h-4 w-2 bg-white" />
    <span className="h-4 w-2 bg-[#EF4135]" />
  </span>
);

export default function About() {
  const year = new Date().getFullYear();
  return (
    <div className="grid-bg min-h-[calc(100vh-4rem)]">
      <div className="mx-auto max-w-3xl px-4 py-12 md:px-8">
        <div className="mb-8 flex items-center gap-2 animate-fade-up">
          <Info className="h-6 w-6 text-primary" />
          <h1 className="font-head text-3xl font-extrabold tracking-tight">À propos</h1>
        </div>

        <div className="space-y-6">
          <section className="rounded-xl border border-[#1E2638] bg-[#0F141C] p-6">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
                <Cpu className="h-5 w-5" />
              </span>
              <span className="font-head text-lg font-extrabold">
                llm<span className="text-primary">etric</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-muted-foreground">
              llmetric analyse votre matériel (CPU, RAM, GPU, VRAM, accélérateur) et recommande les modèles LLM
              open source que vous pouvez exécuter localement, avec les quantifications adaptées et les commandes
              d'installation (Ollama, LM Studio, llama.cpp, apps iPhone).
            </p>
          </section>

          <section className="rounded-xl border border-[#1E2638] bg-[#0F141C] p-6" data-testid="about-copyright">
            <div className="mb-3 h-1 w-24 rounded-full bg-gradient-to-r from-[#0055A4] via-white to-[#EF4135]" />
            <div className="flex items-center gap-3">
              <Tricolore />
              <p className="text-base">
                © {year} <span className="font-semibold text-foreground">Habily Bouchaib</span>
                <span className="text-muted-foreground"> · France</span>
              </p>
              <Tricolore />
            </div>
          </section>

          <section className="rounded-xl border border-amber-800/60 bg-amber-950/20 p-6" data-testid="about-disclaimer">
            <div className="mb-2 flex items-center gap-2 text-amber-400">
              <ShieldCheck className="h-5 w-5" />
              <h2 className="font-head text-base font-bold">Avertissement & confidentialité</h2>
            </div>
            <p className="text-sm leading-relaxed text-slate-300">
              Il s'agit d'une <span className="font-semibold text-foreground">solution de test</span>. Aucune donnée
              n'est analysée à des fins autres que la sauvegarde des choix de l'utilisateur.
            </p>
            <p className="mt-3 flex flex-wrap items-center gap-1.5 text-sm text-slate-300">
              <Mail className="h-4 w-4 text-primary" />
              Toute demande de suppression de données nominatives est à envoyer à
              <a
                href="mailto:bhabily@hotmail.com"
                data-testid="about-contact-email"
                className="font-medium text-primary hover:underline"
              >
                bhabily@hotmail.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
